<section
    class=" content2-bg-image no-padding cover-background xs-bg-none border-none bg-img-ten header-margin-top-medium"
    id="" data-img-size="(W)1920px X (H)590px"
    style="background: linear-gradient(rgba(0, 0, 0, 0.00784314), rgba(0, 0, 0, 0.00784314)), url('assets/images/bg-image/bg-home-empresa.jpg') fixed;">
    <div class="container sm-width-100 sm-no-padding">
        <div
            class="bg-cream  width-80 sm-width-60 xs-width-100 content-style1 padding-four md-padding-eight sm-padding-eighteen">
            <!-- section title -->
            <h2
                class="title alt-font title-extra-large-2 sm-title-extra-large-2 xs-section-title-large text-brown margin-one-bottom">
                Área de usuario - Ingresar contraseña nueva </h2>
            <!-- end section title -->
            <div *ngIf="error" class="text-orange"> {{ error }}</div>
            <form [formGroup]="formPassword" class="form-signin" (ngSubmit)="onSubmit()">
                <div class="form-group">
                    <label for="nuevaContrasena">Nueva contraseña</label>
                    <input type="password" formControlName="nuevaContrasena" class="form-control"
                        [ngClass]="{ 'is-invalid': submitted && f.nuevaContrasena.errors }" />
                    <div *ngIf="submitted && f.nuevaContrasena.errors" class="invalid-feedback">
                        <div *ngIf="f.nuevaContrasena.errors.required">Nueva contraseña requerida</div>
                        <div *ngIf="f.nuevaContrasena.errors.minlength">Nueva contraseña debe contener al menos 6
                            caracteres</div>
                        <div *ngIf="f.nuevaContrasena.errors.mismatch">Las contraseñas son distintas</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="confirmarContrasena">Confirmar contraseña</label>
                    <input type="password" formControlName="confirmarContrasena" class="form-control"
                        [ngClass]="{ 'is-invalid': submitted && f.confirmarContrasena.errors }" />
                    <div *ngIf="submitted && f.confirmarContrasena.errors" class="invalid-feedback">
                        <div *ngIf="f.confirmarContrasena.errors.required">Confirmar contraseña requerida</div>
                        <div *ngIf="f.confirmarContrasena.errors.minlength">Confirmar contraseña debe contener al menos
                            6 caracteres </div>
                        <div *ngIf="f.confirmarContrasena.errors.mismatch">Las contraseñas son distintas</div>
                    </div>
                </div>
                <div style="display: inline-flex">
                    <button class="btn-medium btn-circle btn bg-dark-brown text-white" type="submit">RECUPERAR</button>
                </div>
            </form>
            <br>
            <a routerLink="/registro" routerLinkActive="active" class="text-orange float-right">¿Aún no posee una
                cuenta? Regístrese aquí.</a><br>
        </div>
    </div>
</section>
